import React from "react";
import { Form, Input } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const { TextArea } = Input;

const FormTextArea = (props) => {
  // -------------------------- VAR -----------------------------
  const label = props.label;
  const name = props.name || "Tên";
  const placeholder = props.placeholder || "Nhập Mô Tả";
  const className = props?.className || "";
  const rules = props?.rules || [];
  const rows = props?.rows || 3;
  const disabled = props?.disabled || false;
  const initialValue = props?.initialValue;
  const showCount = props?.showCount;
  const variant = props?.variant || "outlined";
  const readOnly = props?.readOnly || false;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={initialValue}
      rules={rules}
    >
      <TextArea
        className={className}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        showCount={showCount}
        variant={variant}
      />
    </Form.Item>
  );
};
export default FormTextArea;
